/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_A1Inputs */

const en_dr_faq_a1 = /** @type {(inputs: Dr_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The room owner needs one; everyone else joins with a link and a name — a signed guest token, no sign-up, no password.`)
};

const id_dr_faq_a1 = /** @type {(inputs: Dr_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Pemilik ruang perlu akun; peserta lain cukup masuk lewat tautan dan nama — token tamu bertanda tangan, tanpa daftar, tanpa kata sandi.`)
};

/**
* | output |
* | --- |
* | "No. The room owner needs one; everyone else joins with a link and a name — a signed guest token, no sign-up, no password." |
*
* @param {Dr_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_a1 = /** @type {((inputs?: Dr_Faq_A1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_A1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_a1(inputs)
	return en_dr_faq_a1(inputs)
});